import { useTranslation } from "react-i18next";
import { cn } from "@/lib/style/cva.config";

interface ReserveBadgeProps {
  className?: string;
}

export function ReserveBadge({ className }: ReserveBadgeProps) {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        "w-fit rounded-md border border-txt-brand bg-brand-100 px-2 py-1 text-xs font-semibold text-txt-brand transition-colors hover:bg-brand-200",
        className,
      )}
    >
      {t("common:reserve")}
    </div>
  );
}
